import { useNavigate } from 'react-router-dom';

import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { ICollection } from '../types';
import { CollectionRow } from './collection-row';
import { PATH_DASHBOARD } from '@app/routes/paths';

const TABLE_HEAD = [
  { id: 'Id', label: 'Id', align: 'left', sortable: false },
  { id: 'productImage', label: 'Image', align: 'left', sortable: false },
  { id: 'name', label: 'Name', align: 'center', sortable: false },
  { id: 'skuId', label: 'SKU Id', align: 'center', sortable: false },
  { id: 'desc', label: 'Description', align: 'center', sortable: false },
  { id: 'active', label: 'Active/InActive', align: 'left ', sortable: false },
  { id: 'action', label: 'Action', align: 'left ', sortable: false },
];

interface Props {
  tableProps: TableProps;
  rows?: ICollection[];
  loading: boolean;
  count?: number;
}

const CollectionList = ({ tableProps, rows, loading, count }: Props) => {
  const navigation = useNavigate();

  const handleSelect = (data: any) => {
    navigation(PATH_DASHBOARD.collectionDetail, { state: data });
  };
  return (
    <PaginatedTable<ICollection>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={true}
      totalCount={count}
    >
      {(row) => (
        <CollectionRow
          row={row}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            handleSelect(row);
          }}
        />
      )}
    </PaginatedTable>
  );
};
export default CollectionList;
